import { Product } from '../layout/mountProduct';
import { pubSub } from '@utils/PubSub';
import '../../style/templates/product.scss';
import '@modules/PdpNotification';
import InternationalToast from '@modules/internationalToast';
import SizeGuide from '../components/size-guide.js';
import TabbedCardsModule from '@modules/tabbedCards';

document.addEventListener('DOMContentLoaded', () => {
  const productEl = document.querySelector('main-product');
  new Product(productEl);
  new InternationalToast();
  if (document.querySelector('.js-size-guide')) {
    document.querySelectorAll('.size-guide__container').forEach((table) => {
      let sizeGuide = new SizeGuide(table);
      sizeGuide.init();
    });
  }
  const tabbedCardsModule = document.querySelectorAll(
    '.js-tabbed-cards-module'
  );
  tabbedCardsModule.forEach((module) => new TabbedCardsModule(module));
});
